import { combineReducers } from "redux"
import cart from "./CartReducer"

export default combineReducers({ cart })
